import './style.scss'

import React, { Component } from 'react'

import PropTypes from 'prop-types'

class PageHeader extends Component {
    render() {
        const { h1, children, headerClass, hideOnMobile = true } = this.props

        return (
            <div className="page-header">
                {h1 && <h1 className={`${headerClass} ${hideOnMobile ? 'hide' : ''}`}>{h1}</h1>}
                {children}
            </div>
        )
    }
}

PageHeader.propTypes = {
    h1: PropTypes.string,
    headerClass: PropTypes.string,
    hideOnMobile: PropTypes.bool,
}

export default PageHeader
